import {RecipeRecordModel} from "./RecipeRecordModel";

export class RecipeResponseModel {
    Roots: RecipeRecordModel[];

    constructor() {
        this.Roots = [];
    }
}